<template>
  <div>
    <Modal :close-name="$t('global.cancel')" :title="title" :hide-footer="true" @close="cancel">
      <template #body>
        <p style="white-space: pre-wrap;">{{ message }}</p>
        <div class="modal-footer">
          <Btn class="mr-2" variant="light" type="button" :disabled="loading" @click="cancel">
            {{ $t("global.cancel") }}
          </Btn>
          <Btn
            :variant="variant"
            type="button"
            :disabled="loading"
            :loading="loading"
            @click="confirmWrapper"
          >
            {{ $t("global.confirm") }}
          </Btn>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import { computed, ref } from "@vue/composition-api";
import Btn from "@/components/display/Btn";
import Modal from "@/components/display/Modal";
import store from "@/store";

export default {
  name: "ConfirmationModal",
  props: {
    data: Object,
  },
  components: {
    Btn,
    Modal,
  },
  setup(props, { emit }) {
    const loading = ref(false);
    const message = computed(() => props.data?.message);
    const title = computed(() => props.data?.title || "");
    const variant = computed(() => props.data?.variant || "primary");
    const cancel = () => {
      emit("close");
    };
    const confirmWrapper = () => {
      loading.value = true;
      props.data
        .confirm()
        .then(() => {
          if (props.data.onSuccess) {
            props.data.onSuccess();
          }
          emit("close");
        })
        .catch(() => {
          store.dispatch("toasts/addToast", {
            variant: "error",
            message: props.data?.errorMessage || root.$t("global.confirmation-error-message"),
            timeout: true,
          });
          emit("close");
        })
        .finally(() => {
          loading.value = false;
        });
    };

    return {
      cancel,
      confirmWrapper,
      loading,
      message,
      title,
      variant,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables";
</style>
